import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Card } from './Card';

export interface EmployeeBaseCardProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  to?: string;
}

export const EmployeeBaseCard: React.FC<EmployeeBaseCardProps> = ({
  className,
  children,
  onClick,
  to,
}) => {
  const containerClasses = twMerge(
    'flex flex-col w-full min-w-0 max-w-full h-full min-h-ds-employee-card gap-8 p-2 pt-5',
    className,
  );
  return (
    <Card to={to} className={containerClasses} onClick={onClick}>
      {children}
    </Card>
  );
};
